define('Components/AboutComeInWidget/js/model/AboutComeInWidgetModel',['underscore', 'WidgetInstanceModel', 'app', 'UrlFactory', 'formatPrice'],
  function (_, WidgetInstanceModel, app, UrlFactory, formatPrice) {

  var advantages = [], status = [];
    // staticly added advantages
    function registerAdvantage(id,ichi,ni,san){
      var status = [];
      if(ichi) status.push('ichi');
      if(!san && ni) status.push('nosan');
      if(ni) status.push('ni');
      if(san) status.push('san');
      advantages.push({
        id:id,
        active:[ichi,ni,san],
        ichi:ichi,
        ni:ni,
        san:san,
        status:status, // base status
      })
    }
    registerAdvantage('1sign4birthday',true,true,true);
    registerAdvantage('5eur',true,true,true);
    registerAdvantage('5pclandco',true,true,true);
    registerAdvantage('2xy',false,true,true);
    registerAdvantage('ppoffert',false,true,true);
    registerAdvantage('1sushiday',false,true,false);
    registerAdvantage('2sushiday',false,false,true);
    registerAdvantage('freefees',false,false,true);
    registerAdvantage('1boxfree',false,false,true);

    function registerStatus(name,h6){
      status.push({
        id:name.toLowerCase(),
        name:name,
        h6:h6,
        n:status.length+1,
      })
    }
    registerStatus(
        'Ichi',
        'Pour 1 commande et un montant de 1€'
    );
    registerStatus(
        'Ni',
        'Pour 6 commandes et un montant de 150€'
    );
    registerStatus(
        'San',
        'Pour 24 commandes et un montant de 1000€'
    );

    return WidgetInstanceModel.extend({
      name: 'AboutComeInWidgetModel',
      setup:function(){
        var model = this;
        model.listAdvantages().each(function(advantage){
          var id = advantage.id, id_prefix = 'advantage_'+id;
            advantage.desc_front = model.p(id_prefix+'_desc_front');
            advantage.desc_back = model.p(id_prefix+'_desc_back');
            advantage.img = model.getParamImgUrl(id_prefix+'_img','noscale','jpg','advantage');
        });
        model.listStatus().each(function(status){
          var id = status.id, id_prefix = 'advantage_'+id;
          status.title = model.p(id_prefix+'_title');
          status.subtitle = model.p(id_prefix+'_subtitle');
          status.orders_count = model.p(id_prefix+'_orders_count');
          status.orders_amount = model.p(id_prefix+'_orders_amount');
        });
      },
      formatPrice:function(price){
        var format = {
          auto_round_decimal:true,
          ignore_space:true,
        };
        return formatPrice(price,format);
      },
      listAdvantages:function(){
        return _(advantages);
      },
      listStatus:function(){
        return _(status);
      },
      tableText:function(textId){
        var translationKey = '-';
        if(textId === '1sign4birthday'){
          translationKey = '1 Signature Roll offert pour mon anniversaire';
        }else if(textId === '5eur'){
          translationKey = "5€ de bienvenue lorsque je m'inscris en Shop";
        }else if(textId === '5pclandco'){
          translationKey = "5% cagnottés sur mes commandes à emporter, Click & Collect et sur place";
        }else if(textId === '2xy'){
          translationKey = "2 fois par an, une délicate attention glissée dans votre commande";
        }else if(textId === 'ppoffert'){
          translationKey = "Mon produit préféré offert pour mon anniversaire d’inscription***";
        }else if(textId === '1sushiday'){
          translationKey = "1 #sushiday par an -20% sur votre commande";
        }else if(textId === '2sushiday'){
          translationKey = "2 #sushiday par an -20% sur votre commande";
        }else if(textId === 'freefees'){
          translationKey = "Frais de gestion offert sur mes commandes en livraison";
        }else if(textId === '1boxfree'){
          translationKey = "1 Box offerte par an**";
        }
        return app.t(translationKey,'ComeIn');
      }
  })
});
